import persistentStore from '../persistentStore'

/**
 * Creates a service object for interacting with category-related API endpoints.
 *
 * @param {string} baseUrl - The base URL of the API.
 * @param {string} endpoint - The specific endpoint for categories.
 * @returns {Object} An object containing methods to interact with the category API.
 * @property {Function} getCategories - Fetches the list of categories from the API.
 * @property {Function.getCategories} getCategories - An asynchronous function that retrieves categories.
 * @throws {Error} Throws an error if the fetch operation fails.
 */
const categoryServices = (baseUrl, endpoint) => ({
  getCategories: async () => {
    const response = fetch(`${baseUrl}/${endpoint}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: persistentStore.getToken(),
        app: process.env.REACT_APP_APPLICATION_NAME
      }
    })

    return (await response).json()
  }
})

export default categoryServices(
  process.env.REACT_APP_API_PRODUCT_PATH,
  'product-types'
)
